// Module
var code = `<ng-form name="\$ctrl.form">
    <div class="profile-related-people">
      <div ng-if="\$ctrl.countRelatedPeople() < \$ctrl.getMinRelatedPeople()" class="alert">
        <span>At least {{\$ctrl.getMinRelatedPeople()}} related people are needed!</span>
        <input class="hidden-element" disabled ng-required="true" ng-model="nonExistingValue"/>
      </div>
        <customer-profile-related-customers profile="\$ctrl.profile"
                                            edit-mode="\$ctrl.editMode">
        </customer-profile-related-customers>

        <customer-profile-related-non-customers relatives="\$ctrl.profile.relatedNonCustomers"
                                                customer-type="\$ctrl.profile.customerType"
                                                edit-mode="\$ctrl.editMode">
        </customer-profile-related-non-customers>
    </div>
</ng-form>
<div class="clearfix"></div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/related-people.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;